import { docIdCodes, transferDocs } from "../../../data/docCodes";
import { stdObject } from "../../../data/types/stdObject";
import { sendData } from "../../../services/sendData";
import { toPrice } from "../../../utils/toPrice";

export const openDocTransfer = async ({
  level,
  docValues,
  openModal,
  closeMsg,
  items,
  country,
  userAccess,
  logoutAction,
}: stdObject) => {
  openModal(level, "loading");
  const { type, itemType, serie, code } = docValues;
  const payloadDocTransfer = { type, itemType, serie, code };

  console.log("payloadDocTransfer: ", payloadDocTransfer);
  const resultDocTransfer: stdObject = await sendData({
    endPoint: "callDocTransfer",
    payload: payloadDocTransfer,
    logoutAction,
  });
  console.log("resultDocTransfer", resultDocTransfer);
  if (resultDocTransfer.success && resultDocTransfer.items.length > 0) {
    const totals = { NET: 0, IMP: 0, TOT: 0, PCO: 0 };
    resultDocTransfer.items = resultDocTransfer.items.map((e: stdObject) => {
      const transferList = resultDocTransfer.transfer.filter(
        (v: stdObject) =>
          v.ARTNEX === e[`ART${itemType}`] && v.LINNEX === e[`LIN${itemType}`],
      );
      const transferTotal = transferList.reduce(
        (acc: number, curr: stdObject) => acc + curr.CANNEX,
        0,
      );
      const quantity = e[`CAN${itemType}`] - transferTotal;
      const net = e[`PRE${itemType}`] * quantity;
      const tax = (net * e[`IMP${itemType}`]) / 100;
      totals.NET += net;
      totals.IMP += tax;
      totals.TOT += net + tax;
      totals.PCO +=
        quantity * (items[e[`ART${itemType}`]]?.PREPCO[country] ?? 0);
      return {
        ...e,
        active: quantity > 0,
        quantity,
        maxQuantity: quantity,
        transferList,
        transferTotal,
      };
    });

    openModal(level, "transferModal", {
      type,
      serie,
      code,
      open: resultDocTransfer.items.some(
        (e: stdObject) => e.active && e.quantity > 0,
      ),
      items: resultDocTransfer.items,
      previous: resultDocTransfer.previous,
      next: resultDocTransfer.next,
      target:
        transferDocs[type as keyof typeof transferDocs].filter((e: string) => {
          const idCode = docIdCodes[e];
          return idCode ? userAccess[idCode[0]][idCode] : false;
        })[0] ?? -1,
      NET: toPrice(totals.NET),
      IMP: toPrice(totals.IMP),
      TOT: toPrice(totals.TOT),
      PCO: totals.PCO,
    });
    /*setMsg("transferModal");
    setModalData({
      type,
      serie,
      code,
      open: resultDocTransfer.items.some(
        (e: stdObject) => e.active && e.quantity > 0,
      ),
      items: resultDocTransfer.items,
      previous: resultDocTransfer.previous,
      next: resultDocTransfer.next,
      target:
        transferDocs[type as keyof typeof transferDocs].filter((e: string) => {
          const idCode = docIdCodes[e];
          return idCode ? userAccess[idCode[0]][idCode] : false;
        })[0] ?? -1,
      NET: toPrice(totals.NET),
      IMP: toPrice(totals.IMP),
      TOT: toPrice(totals.TOT),
      PCO: totals.PCO,
    });*/
    return true;
  }
  closeMsg(level);
};
